
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.364 17.364a8.998 8.998 0 000-12.728 8.998 8.998 0 00-12.728 0 8.998 8.998 0 000 12.728c3.516 3.515 9.216 3.515 12.728 0zm-9.59-7.74l2.023 2.024 4.433-4.43L15.8 8.788l-4.43 4.43-1.572 1.568-1.568-1.568-2.024-2.024 1.568-1.569z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_check_mark.svg